import template from './trip-flight-passenger-seat-info.html';

const DIRECTIVE_NAME = TripFlightPassengerSeatInfo.DIRECTIVE_NAME = 'ktTripFlightPassengerSeatInfo';
export default function TripFlightPassengerSeatInfo() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: TripFlightPassengerSeatInfoController,
        controllerAs: '$ctrl',
        scope: {
            travellers: `=${DIRECTIVE_NAME}Travellers`,
            flightPassengers: `=${DIRECTIVE_NAME}FlightPassengers`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function TripFlightPassengerSeatInfoController(
    tripFlightPassengerSeatInfoService,
    userService,
    tripTravellerAllocationPassengerService,
    l10nService,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        isChild: tripTravellerAllocationPassengerService.isChild,
        isSeatStatusUnconfirmed: tripFlightPassengerSeatInfoService.isSeatStatusUnconfirmed,
        l10nService,
    });

    function $onInit() {
        vm.currencySign = userService.getRegionalSettings().currencySign;
        vm.seatMaps = tripFlightPassengerSeatInfoService
            .associateSeatsWithTravellers(vm.travellers, vm.flightPassengers)
            .filter(({SeatNumber}) => !!SeatNumber);

        vm.isSeatInfoSectionVisible = vm.seatMaps.length > 0
            && vm.seatMaps.some((item) => item.SeatNumber);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-flight-passenger-seat-info/trip-flight-passenger-seat-info-component.js